import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
	clearAdvanceFilter,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../../../../store/action/advanceFilter';
import {
	fetchPaymentsReceivedList,
	generateSalesPaymentReceivedPdf,
} from '../../../../../services/payments_received';
import { getDate } from '../../../../../utils/dateUtils';
import { formatFilterName, getFiltersParams } from '../../../../../helper';
import { toast } from 'react-toastify';
import { hasPermission } from '../../../../../utils/controller';

const UsePaymentReceived = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [bulkAction, setBulkAction] = useState([]);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [deselectRows, setDeselectRows] = useState(null);
	const [headerDropDown, setHeaderDropDown] = useState('All Payments Received');
	const [sortDirection, setSortDirection] = useState({ id: 'asc' });
	const suburl = localStorage.getItem('suburl');
	const dispatch = useDispatch();
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		orderBy: advanceFilterOrderby,
		sortBy: advanceFilterSortBy,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);
	const [paymentReceivedList, setPaymentRecieved] = useState({
		data: [],
		totalPages: 0,
		currentPage: 1,
	});
	const [paymentReceievedParams, setPaymentRecievedParams] = useState({
		page: Number(searchParams.get('page')) || 1,
		page_size: Number(searchParams.get('page_size')) || 20,
		order_by: searchParams.get('order_by') || 'desc',
		sort_by: searchParams.get('sort_by') || 'created_at',
		filters: {},
	});

	const [isLoading, setLoading] = useState(false);
	const [isLoader, setLoader] = useState(false);
	const navigate = useNavigate();
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};
	const handlePageChange = (page) => {
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilterPage({ page }));
		} else {
			setPaymentRecievedParams((prev) => ({
				...prev,
				page,
			}));
		}
	};

	const onRowClick = (id) => {
		if (id && hasPermission('sales.payments_received.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/payments-received-details/${id}`);
		}
	};
	const FilterDatalist = (dropDownData) => {
		if (isAdvanceFilterApplied && dropDownData === 'All Payments Received') {
			dispatch(clearAdvanceFilter());
			setHeaderDropDown('All Payments Received');
			return;
		}
		if (dropDownData === 'Customer Name') {
			dispatch(setSelectedInput({ key: 'customer_name', label: 'Customer Name' }));
			dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
			return;
		}
		if (dropDownData === 'Payment Type') {
			dispatch(setSelectedInput({ key: 'payment_mode', label: 'Payment Mode' }));
			dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
			return;
		}
		setHeaderDropDown(dropDownData);
		const updatedSelectedInput = selectedInputs.map((input) => {
			if (input.key === 'status') {
				return {
					...input,
					value: dropDownData,
				};
			}
			return input;
		});
		dispatch(setSelectedInput({ key: 'status', label: 'Status' }));
		dispatch(setSelectedInputValue({ key: 'status', value: dropDownData }));
		dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
		var selectInputData = [
			{ key: 'cash', value: 'Cash Payments' },
			{ key: 'online', value: 'Online Payments' },
		];
		dispatch(setSelectedInputData({ key: 'status', data: selectInputData }));
		const params = getFiltersParams(updatedSelectedInput);
		handleApplyFilters(params);
	};

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.sort_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.sort_by]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ order_by: newDirection, sort_by: param.sort_by }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setPaymentRecievedParams((prev) => ({
				...prev,
				order_by: newDirection,
				sort_by: param.sort_by,
			}));
		}
	};
	async function handleOnFocusSelectedFilterInput(key) {
		let selectInputData = [];
		if (key !== 'status') {
			const { payment_receives } = await fetchPaymentsReceivedList({
				...paymentReceievedParams,
				page_size: 1000,
			});
			if (key === 'customer_name') {
				selectInputData = payment_receives
					?.filter((item) => item['customer'])
					?.map((pr) => ({
						key: pr?.customer?.name,
						value: pr?.customer?.name,
					}));
			} else if (key === 'payment_mode') {
				selectInputData = payment_receives?.map((pr) => ({
					key: pr?.payment_mode_id,
					value: pr?.payment_mode?.payment_method_name,
				}));
			} else {
				selectInputData = payment_receives
					?.filter((item) => item[key])
					?.map((pr) => ({
						key: pr[key],
						value: pr[key],
					}));
			}
		} else {
			selectInputData = [
				{ key: 'cash', value: 'Cash Payments' },
				{ key: 'online', value: 'Online Payments' },
			];
		}
		dispatch(setSelectedInputData({ key, data: selectInputData }));
	}
	async function handleApplyFilters(params) {
		try {
			if (Object.keys(params).length === 0) {
				return;
			}
			if (params.status) {
				setHeaderDropDown(params.status);
			}

			const updatedParams = { ...params };

			if (updatedParams.status === 'Cash Payments') {
				updatedParams.status = 'cash';
			}

			if (updatedParams.status === 'Online Payments') {
				updatedParams.status = 'online';
			}
			if (updatedParams.status === 'Customer Name') {
				updatedParams.status = 'customer_name';
			}
			if (updatedParams.status === 'Payment Type') {
				updatedParams.status = 'payment_type';
			}

			var { payment_receives, total_pages } = await fetchPaymentsReceivedList({
				order_by: advanceFilterOrderby,
				sort_by: advanceFilterSortBy,
				page: advanceFilterPage,
				page_size: advanceFilterPageSize,
				filters: updatedParams,
			});

			const paymentLists = mappedTableData(payment_receives);
			setBulkAction([]);
			setPaymentRecieved((prev) => ({
				...prev,
				data: paymentLists,
				totalPages: total_pages,
				currentPage: 1,
			}));
			dispatch(setAdvanceFilterTotalPage({ totalPages: total_pages }));
			setIsAdvanceFilterOpen(false);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong! Try again.');
		}
	}
	async function searchSelectedInputItems(key, value) {
		try {
			let optionsList;
			if (key === 'status') {
				optionsList = [
					{ key: 'cash', value: 'Cash Payments' },
					{ key: 'online', value: 'Online Payments' },
					{ key: 'customer_name', value: 'Customer Name' },
					{ key: 'payment_type', value: 'Payment Type' },
				];
			} else {
				const { payment_receives } = await fetchPaymentsReceivedList({
					page_size: 1000,
					filters: {
						key: value,
					},
				});
				optionsList = payment_receives?.map((pr) => ({
					key: pr[key],
					value: pr[key],
				}));
			}
			dispatch(setSelectedInputData({ key, data: optionsList }));
		} catch (error) {}
	}

	async function handlePrintAndDownloadPdf(
		ids = bulkAction.join(','),
		type = 'print',
		merge = false,
	) {
		try {
			setLoader(true);
			const pdf_details = await generateSalesPaymentReceivedPdf(
				ids === '' ? bulkAction.join(',') : ids,
				merge,
			);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
				return;
			}

			if (type === 'download') {
				const fileName = `${merge ? 'merged' : pdf_details.meta_data.payment_received_number}_sales_payment_received_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoader(false);
		}
	}

	const getPaymentReceived = async () => {
		try {
			setLoading(true);
			var { payment_receives, total_pages, page } =
				await fetchPaymentsReceivedList(paymentReceievedParams);
			if (payment_receives) {
				const paymentsList = mappedTableData(payment_receives);
				setBulkAction([]);
				setPaymentRecieved((prev) => ({
					...prev,
					data: paymentsList,
					totalPages: total_pages,
					currentPage: page,
				}));
			}
		} catch {
		} finally {
			setLoading(false);
		}
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.id,
				DATE: getDate(ele.date),
				'PR#': ele?.payment_receive_number,
				'CUSTOMER NAME': ele.customer?.name || 'N/A',
				'PAYMENT MODE': ele?.payment_mode?.payment_method_name || 'N/A',
				AMOUNT: ele?.cash_handed || 'N/A',
				'UNUSED AMOUNT': ele?.excess_payment_amount || 'N/A',
			};
		});
	}

	const setHeaderDropdownStatus = (filters) => {
		const statusMap = {
			cash: 'Cash Payments',
			online: 'Online Payments',
		};
		if (filters.status !== undefined) {
			setHeaderDropDown(statusMap[filters.status]);
		}
	};

	const setFilterFromUrl = () => {
		const filters = {};
		searchParams.forEach((value, key) => {
			if (key !== 'page' && key !== 'page_size' && key !== 'order_by' && key !== 'sort_by') {
				filters[key] = value;
			}
		});
		setSortDirection({
			[searchParams.get('sort_by')]: searchParams.get('order_by') || '',
		});
		setHeaderDropdownStatus(filters);
		Object.entries(filters).forEach(([key, value]) => {
			const statusValueMap = {
				cash: 'Cash Payments',
				online: 'Online Payments',
			};
			const fieldValue = key === 'status' ? statusValueMap[value] : value;
			dispatch(
				setSelectedInput({
					key: key,
					label: key === 'payment_receive_number' ? 'Payment #' : formatFilterName(key),
				}),
			);
			dispatch(
				setSelectedInputValue({
					key: key,
					value: fieldValue,
				}),
			);
			handleOnFocusSelectedFilterInput(key);
		});
		if (Object.keys(filters).length > 0) {
			dispatch(
				setAdvanceFilter({
					isAdvanceFilterApplied: true,
					page: Number(searchParams.get('page')) || 1,
					pageSize: Number(searchParams.get('page_size')) || 20,
					order_by: searchParams.get('order_by') || 'created_at',
					sort_by: searchParams.get('sort_by') || 'desc',
				}),
			);
		}
	};

	useEffect(() => {
		setFilterFromUrl();
	}, []);

	function getParams(params) {
		const status = params.status;
		if (!status) return params;
		setHeaderDropDown(status);
		const statusMap = {
			'Cash Payments': 'cash',
			'Online Payments': 'online',
		};
		return {
			...params,
			status: statusMap[status],
		};
	}

	const setUrlSearchParams = () => {
		const url = new URLSearchParams();
		// Normal params
		url.set('page', isAdvanceFilterApplied ? advanceFilterPage : paymentReceievedParams.page);
		url.set(
			'page_size',
			isAdvanceFilterApplied ? advanceFilterPageSize : paymentReceievedParams.page_size,
		);
		url.set(
			'order_by',
			isAdvanceFilterApplied ? advanceFilterOrderby : paymentReceievedParams.order_by,
		);
		url.set(
			'sort_by',
			isAdvanceFilterApplied ? advanceFilterSortBy : paymentReceievedParams.sort_by,
		);
		if (selectedInputs.length > 0) {
			const filters = getParams(getFiltersParams(selectedInputs));
			Object.entries(filters).forEach(([key, value]) => {
				if (value !== undefined && value !== null && value !== '') {
					url.set(key, value);
				}
			});
		}
		setSearchParams(url);
	};

	useEffect(() => {
		setUrlSearchParams();
	}, [
		paymentReceievedParams,
		selectedInputs,
		advanceFilterPage,
		advanceFilterPageSize,
		advanceFilterOrderby,
		advanceFilterSortBy,
		isAdvanceFilterApplied,
	]);

	useEffect(() => {
		const stockFilterKeys = ['customer_name', 'payment_mode', 'payment_receive_number', 'status'];
		const hasStockFilter = stockFilterKeys.some((key) => searchParams.has(key));
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			if (!hasStockFilter) {
				getPaymentReceived();
			}
		}
	}, [searchParams, isAdvanceFilterApplied]);

	return {
		user,
		paymentReceivedList,
		paymentReceievedParams,
		onRowClick,
		isLoading,
		bulkAction,
		navigate,
		suburl,
		setBulkAction,
		deselectRows,
		FilterDatalist,
		dispatch,
		headerDropDown,
		setHeaderDropDown,
		isAdvanceFilterApplied,
		setIsAdvanceFilterOpen,
		sortDataList,
		sortDirection,
		advanceFilterPage,
		advanceFilterPageSize,
		advanceFilterTotalPages,
		handleOnFocusSelectedFilterInput,
		handleApplyFilters,
		searchSelectedInputItems,
		isAdvanceFilterOpen,
		selectedInputs,
		handleDeselectAll,
		handlePageChange,
		isLoader,
		handlePrintAndDownloadPdf,
		setPaymentRecievedParams,
	};
};
export default UsePaymentReceived;
